import { NgModule } from '@angular/core';
import { RichTextPipe } from './rich-text.pipe';

@NgModule({
    declarations: [RichTextPipe],
    exports: [RichTextPipe]
})
export class RichTextModule {}
